import { useTranslation } from 'react-i18next';

import Product from 'components/product/Product';
import {getData} from "components/product/util";

import img1 from 'assets/images/solutions/modules/tr/module_06.png'
import img2 from 'assets/images/solutions/modules/tr/module_07.png'
import img3 from 'assets/images/solutions/modules/tr/module_08.png'
import img4 from 'assets/images/solutions/modules/tr/module_09.png'

export default function ProductTr(){
  const {t} = useTranslation();
  const products = getData(t, "modules", "tr");
 
  // 그림 이름은 대중이 없어서 따로 넣어야 함.
  products[0].images = [img1];
  products[1].images = [img2];
  products[2].images = [img3];
  products[3].images = [img4];

  return (
    <Product products={products}/>
  );
}